// Query key factory for Registry-page queries (entities listed top-level
// in the Registry / Register page).

import type {
  RegistryPatientFilters,
  RegistryRxFilters,
  RegistryDoctorReportFilters,
  RegistryTreatmentNoteFilters,
  DocumentationStatsWindow,
} from "./registryStore";

const scopes = {
  registryPatients: "registryPatients",
  registryRxs: "registryRxs",
  registryDoctorReports: "registryDoctorReports",
  registryDoctorReportTherapistCounts: "registryDoctorReportTherapistCounts",
  registryTreatmentNotes: "registryTreatmentNotes",
  registryDocumentationStats: "registryDocumentationStats",
  registryUndocumentedTreatments: "registryUndocumentedTreatments",
};

export const registryKeys = {
  patients: {
    scope: scopes.registryPatients,
    all: () => [scopes.registryPatients] as const,
    filtered: (filters: RegistryPatientFilters) =>
      [scopes.registryPatients, filters] as const,
  },
  rxs: {
    scope: scopes.registryRxs,
    all: () => [scopes.registryRxs] as const,
    filtered: (filters: RegistryRxFilters) => [scopes.registryRxs, filters] as const,
  },
  doctorReports: {
    scope: scopes.registryDoctorReports,
    all: () => [scopes.registryDoctorReports] as const,
    filtered: (filters: RegistryDoctorReportFilters) =>
      [scopes.registryDoctorReports, filters] as const,
  },
  doctorReportTherapistCounts: {
    scope: scopes.registryDoctorReportTherapistCounts,
    all: () => [scopes.registryDoctorReportTherapistCounts] as const,
    detail: (locationId: string | undefined, status: string) =>
      [scopes.registryDoctorReportTherapistCounts, { locationId, status }] as const,
  },
  treatmentNotes: {
    scope: scopes.registryTreatmentNotes,
    all: () => [scopes.registryTreatmentNotes] as const,
    filtered: (filters: RegistryTreatmentNoteFilters) =>
      [scopes.registryTreatmentNotes, filters] as const,
  },
  documentationStats: {
    scope: scopes.registryDocumentationStats,
    all: () => [scopes.registryDocumentationStats] as const,
    detail: (locationId: string | undefined, window: DocumentationStatsWindow) =>
      [scopes.registryDocumentationStats, { locationId, window }] as const,
  },
  undocumentedTreatments: {
    scope: scopes.registryUndocumentedTreatments,
    all: () => [scopes.registryUndocumentedTreatments] as const,
    detail: (userId: string, window: DocumentationStatsWindow) =>
      [scopes.registryUndocumentedTreatments, { userId, window }] as const,
  },
};
